import { foundationLessons } from "./lessonsFoundations";
import { stockLessons } from "./lessonsStocks";
import { portfolioLessons } from "./lessonsPortfolio";
import { analysisLessons } from "./lessonsAnalysis";
import { productLessons } from "./lessonsProducts";
import { methodLessons } from "./lessonsMethods";
import { marketLessons } from "./lessonsMarkets";
import { riskLessons } from "./lessonsRisk";
import { behaviorLessons } from "./lessonsBehavior";
import { executionLessons } from "./lessonsExecution";

export const courseModules = [
  { id: "foundation", label: "Foundations", title: "先整理自己的錢", description: "收支、預備金與財務目標" },
  { id: "numbers", label: "Numbers", title: "讀懂報酬與風險", description: "複利、年化與回撤" },
  { id: "stocks", label: "Stocks", title: "開始看懂股票", description: "報價、K 棒、成交量與財報" },
  { id: "funds", label: "Funds", title: "認識 ETF 與債券", description: "持有內容、價格、費用與匯率" },
  { id: "strategy", label: "Strategy", title: "建立投資方法", description: "分散、配置、再平衡與退休" },
  { id: "practice", label: "Practice", title: "把判斷變成習慣", description: "查證、防詐與自己的投資計畫" },
  { id: "analysis", label: "Analysis", title: "用財報認識公司", description: "利潤率、ROE、現金流與估值" },
  { id: "products", label: "Products", title: "深入看商品的運作", description: "追蹤、配息、利率、信用與槓桿" },
  { id: "methods", label: "Methods", title: "比較投入方式與成果", description: "定額、現金流、費用與新資金" },
  { id: "markets", label: "Markets", title: "讀懂市場與經濟", description: "物價、利率、景氣與發布數據" },
  { id: "risk", label: "Risk", title: "看懂績效背後的風險", description: "波動、相關、Beta 與回測限制" },
  { id: "behavior", label: "Mindset", title: "看懂自己的投資決策", description: "損失感受、心理偏誤與決策日誌" },
  { id: "execution", label: "Execution", title: "讀懂成交與股數變動", description: "價差、委託、拆股、增資與回購" },
];
const order = [
  "cash-flow", "emergency-fund", "financial-goals", "balance-sheet",
  "compound-inflation", "total-return", "annualized-return", "risk-drawdown",
  "stock-ownership", "stock-quotes", "candlesticks", "volume-moving-average",
  "financial-statements", "eps-pe", "dividends", "order-liquidity",
  "investment-tools", "etf-selection", "etf-nav", "bond-basics", "fund-fees", "overseas-fx",
  "diversification", "asset-allocation", "rebalancing", "retirement-planning",
  "costs-and-fraud", "investment-plan", "investor-bias", "information-check",
  "revenue-margins", "roe-leverage", "book-value", "free-cash-flow",
  "financial-debt", "valuation-growth", "cyclical-earnings", "company-checklist",
  "tracking-difference", "etf-distributions", "bond-yields", "duration-risk",
  "credit-spreads", "bond-fund-maturity", "leveraged-etfs", "currency-hedging",
  "dca-mechanics", "lump-sum-timing", "time-weighted-return",
  "money-weighted-return", "fee-compounding", "rebalancing-contributions",
  "cpi-inflation", "real-interest-rates", "policy-rates", "yield-curve",
  "gdp-growth", "pmi-cycle", "labor-market", "economic-releases",
  "volatility-risk", "correlation-risk", "beta-risk",
  "sharpe-ratio", "tail-risk", "backtest-bias",
  "loss-aversion", "anchoring-bias", "confirmation-bias",
  "herd-fomo", "overconfidence-trading", "decision-journal",
  "bid-ask-spread", "market-limit-orders", "stop-orders",
  "stock-splits", "rights-issues", "share-buybacks",
];
const byId = new Map([...foundationLessons, ...stockLessons, ...portfolioLessons, ...analysisLessons, ...productLessons, ...methodLessons, ...marketLessons, ...riskLessons, ...behaviorLessons, ...executionLessons].map(lesson => [lesson.id, lesson]));
export const lessons = order.map(id => byId.get(id));
